<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="successAction"/>
      </v-col>
      <v-col cols="12">
        <ViewDetailsMain class="my-2" :object="objectDetail" type="UsuarioDetails" :actions="successAction" />
      </v-col>
    </v-row>
    <MainFormDialog v-if="get_dialogMain.dialog" :model="objectMain" :params="paramsDialog" />
    </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import MainFormDialog from '@/components/dialog/main/MainFormDialog'
import ViewDetailsMain from '@/components/details/ViewDetailsMain'
import { Permission } from '@/mixins/permissionMain'
export default {
  mixins: [Permission],
  data: () => ({
    table: {
      modelMain: [],
      showSelect: true,
      singleSelect: true,
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'empresa.usuarios.store' }
        ],
        titles: [
          { text: 'Usuario', value: 'usuario', class: 'black--text' },
          { text: 'Empleado', value: 'empleado.NombreCompleto', class: 'black--text' },
          { text: 'Correo', value: 'email', class: 'black--text' },
          { text: 'Roles', value: 'RolesAsignados', class: 'black--text' },
          { text: 'Departamento', value: 'empleado.departamento.nombre', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: '', value: 'ActionsGral', class: 'black--text', align: 'right' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Editar', icon: 'mdi-pencil', color: 'warning', action: 'updateData', code: 'libre', hidden: 'empresa.usuarios.store' },
          { title: 'Asignar Rol', icon: 'mdi-account-network', color: 'warning', action: 'newDataRoles', code: 'empresa.usuarios.set-rol' },
          { title: 'Cambiar Contraseña', icon: 'mdi-account-key', color: 'info', action: 'updatePasswordData', code: 'empresa.usuarios.change-password' },
          { title: 'Reporte de Permisos', icon: 'mdi-file-pdf-box', color: 'amber darken-2', action: 'ReportePermisosData', code: 'empresa.usuarios.change-password' }
        ]
      },
      footer: {
        paging: true
      }
    },
    objectMain: {},
    paramsDialog: {}
  }),
  components: {
    DataTableMain,
    ViewDetailsMain,
    MainFormDialog
  },
  mounted () {
    this.refreshData({})
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['GETObjectsService', 'GETObjects', 'POSTObjectsService', 'DELETEObjectService', 'getUrlServices', 'GETExportPdftSerice']),
    ...mapMutations(['SHOW_DIALOG_MAIN', 'CLEAR_OBJECTS', 'SET_DATA_SECOUND_MAIN']),
    /* *==========*==========*==========*==========*==========*==========*==========* */
    successAction (item) {
      this[item.action](item)
    },
    ExecuteUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.GETObjects({ url: router })
      } else {
        this.getUrlServices()
      }
    },
    refreshData (item) {
      this.table.header.loading = true
      this.ExecuteUrl('empresa.usuarios.show')
    },
    newData (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'createuser',
        with: 850,
        title: 'Nuevo Usuario',
        body: {
          objectMain: {},
          paramsDialog: {
            form: this.get_UsersForm,
            url: this.get_urls['empresa.usuarios.store'],
            message: 'Registro Agregado Correctamente'
          }
        }
      })
    },
    updateData ({ item }) {
      this.SHOW_DIALOG_MAIN({
        type: 'createuser',
        with: 850,
        title: 'Actualizar Usuario',
        body: {
          objectMain: item,
          paramsDialog: {
            form: this.get_UsersUpdateForm,
            url: this.get_urls['empresa.usuarios.store'],
            message: 'Registro Agregado Correctamente',
            setmodel: true
          }
        }
      })
    },
    updatePasswordData ({ item }) {
      this.SHOW_DIALOG_MAIN({
        type: 'change-password',
        with: 850,
        title: `Cambiar Contraseña ( ${item.usuario} )`,
        body: {
          objectMain: { id: item.id },
          paramsDialog: {
            form: this.get_PasswordUpdateForm,
            url: this.get_urls['empresa.usuarios.change-password'],
            message: 'Registro Actualizado Correctamente',
            setmodel: true
          }
        }
      })
    },
    ReportePermisosData ({ item }) {
      this.GETExportPdftSerice({ url: this.get_urls['empresa.usuarios.rpt.show'], addicional: `?usuario_id=${item.id}` })
      // this.SHOW_DIALOG_MAIN({
      //   type: 'change-password',
      //   with: 850,
      //   title: `Cambiar Contraseña ( ${item.usuario} )`,
      //   body: {
      //     objectMain: { id: item.id },
      //     paramsDialog: {
      //       form: this.get_PasswordUpdateForm,
      //       url: this.get_urls['empresa.usuarios.change-password'],
      //       message: 'Registro Actualizado Correctamente',
      //       setmodel: true
      //     }
      //   }
      // })
    },

    newDataRoles ({ item }) {
      this.SHOW_DIALOG_MAIN({
        type: 'assignrol',
        with: 850,
        title: `Asignar Rol (${item.empleado.NombreCompleto})`,
        body: {
          objectMain: {
            id: item.id,
            usuario: item.usuario,
            NombreCompleto: item.empleado.NombreCompleto
          },
          paramsDialog: {
            form: this.get_AssignRoles,
            url: this.get_urls['empresa.usuarios.set-rol'],
            message: 'Registro Agregado Correctamente',
            setmodel: true
          }
        }
      })
    },
    AddDataDepto ({ item }) {
      this.table.header.loading = true
      const router = this.get_urls['empresa.usuarios.set-depto']
      this.POSTObjectsService({ url: router, data: item })
    },
    daleteDataRol ({ item, model }) {
      this.SHOW_DIALOG_MAIN({
        type: 'assignrol',
        with: 850,
        title: 'Eliminar Rol',
        body: {
          objectMain: {
            id: model.id,
            usuario: model.usuario,
            NombreCompleto: model.empleado.NombreCompleto,
            rol_id: item.id
          },
          paramsDialog: {
            form: this.get_RemoveRol,
            url: this.get_urls['empresa.usuarios.set-rol'],
            message: 'Registro Eliminado Correctamente',
            setmodel: true
          }
        }
      })
    }
    /* *==========*==========*==========*==========*==========*==========*==========* */
  },
  computed: {
    ...mapGetters(['get_urls', 'get_dialogMain', 'get_objects', 'get_object',
      'get_UsersForm', 'get_UsersUpdateForm', 'get_AssignRoles', 'get_RemoveRol', 'get_PasswordUpdateForm']),
    objectDetail () {
      if (this.table.modelMain.length > 0) {
        return this.table.modelMain[0]
      }
      return {}
    }
  },
  watch: {
    get_urls () { this.refreshData({}) },
    get_objects (rows) {
      this.table.header.loading = true
      if (rows) {
        this.table.modelMain = []
        if (rows.length > 0) this.table.modelMain.push(rows[0])
        this.table.header.loading = false
        this.table.body.data = rows
      }
    },
    get_object (model) {
      this.table.modelMain = []
      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Existoso!!',
        text: 'Departamentos agregados correctamente',
        timer: 2000
      })
      let usuario = {}
      usuario = this.table.body.data.find(item => item.id === model.id)
      usuario.departamentos_asignados = model.departamentos_asignados

      this.table.modelMain.push(usuario)
      this.table.header.loading = false
    }
  },
  beforeDestroy () {
    this.CLEAR_OBJECTS()
  }

}
</script>

<style>

</style>
